import {
  IntroBlock,
  MyPhoto,
  Text,
  Name,
  Article,
  HireMeButton,
  StyledButtonImg,
  ArrowDown,
} from "./styled";
import dragonLight from "../../images/meLight.svg";
import dragonDark from "../../images/meDark.svg";
import text from "../../images/logoForBright.webp";
import textDark from "../../images/logoForDark.webp";
import arrowDown2 from "../../images/arrowDown2.svg";
import arrowDown3 from "../../images/arrowDown3.svg";
import arrowDown from "../../images/arrowDown.svg";
import { useSelector, useDispatch} from "react-redux";
import { selectIsLightMode } from "../../features/DataSlice/dataSlice";
import { Link } from "react-scroll";
import { useEffect, useState } from "react";
import {
  fetchData,
  selectIsLoading,
} from "../../features/DataSlice/dataSlice";
import LoadingPage from "../../features/TechnicalTabs/LoadingPage";
import ErrorPage from "../../features/TechnicalTabs/ErrorPage";
import { toggleBodyOverflowToFalse } from "../../features/DataSlice/dataSlice";

function AboutMe() {
  const dispatch = useDispatch();
  const theme = useSelector(selectIsLightMode);
  const isLoading = useSelector(selectIsLoading);
   const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, [theme]); // używamy theme, nie isLightMode
  
  

  useEffect(() => {
    dispatch(fetchData());
    dispatch(toggleBodyOverflowToFalse());
  }, []);
if (!mounted) return null;
  let returned = "";

  switch (isLoading) {
    case "loading":
      returned = <LoadingPage/>;
      break;
    case "success":
      returned = (
        <>
          <IntroBlock>
          <MyPhoto
              src={theme ? dragonLight : dragonDark}
              alt="My Photo"
              themes={theme}
            />
            <Text>TO JEST</Text>
            <Name src={theme ? text : textDark} />
            <Article>
            Dragonscape – to jedno i jedyne narzędzie, jakiego potrzebujesz by zbudować dochodowy biznes w świecie internetu. Czy to nie moment, na który czekałeś?
            </Article>
            <HireMeButton 
            activeClass="active"
            to="contactSection"
            spy={true}
            smooth={false}
            offset={160}
            duration={850}>
              <StyledButtonImg isLightMode={theme}/>
            </HireMeButton>
          </IntroBlock>
          <Link
            activeClass="active"
            to="VideoSection"
            spy={true}
            smooth={false}
            offset={-140}
            duration={850}
          >
            <ArrowDown src={theme ? arrowDown3 : arrowDown} ></ArrowDown>
          </Link>
        </>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage/>;
  }

  return returned;
}

export default AboutMe;
